import React, { useEffect, useState } from 'react'
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { toast } from 'react-toastify';
import { CaSearchFilter } from '../searchCorrectiveActionTemplate/CaSearchFilter';
import { Tabindex } from '../../../utils/typeConstants';
import { ControlDialogBox } from '../../../components/controlDialogBox/ControlDialogBox';
import CreatedTemplateIcon from '../../../assets/TemplateCreatedSuccessIcon.png';
import { useGetCaLanguageQuery, useGetCaSeverityLevelQuery } from '../configureCorrectiveActionTemplate/CaConfigure.slice'
import {
    useGetCaApprovalOptionsQuery,
    useGetCaApproverRolesQuery,
    useGetCaTemplateQuery,
    useInsertCaApprovalQueuesMutation,
    useGetCaApprovalQueuesByTemplateIdQuery
} from '../../../pages/correctiveActions/correctiveActionsSlice'
import { Template, Country, Category, Role } from '../type';
import './CreateTemplateApprovalQueues.scss'
import { LoadingSpinner } from '../../../components/loadingSpinner/loadingspinner';


interface CreateTemplateApprovalQueuesePropTypes {
    selectedCountry: Country,
    selectedCategory: Category,
    selectedRole: Role,
    selectedCaTemplate: Template,
    selectedLanguage?: number,
    isUpdateApprovalQueues: boolean,
    setSelectedLanguage: (e: number) => void;
    setActiveIndex: (e: number) => void;
    setSelectedCaTemplate: (e: Template) => void;
    resetFilter: () => void;
}

export const CreateTemplateApprovalQueues = ({
    selectedCountry,
    selectedCategory,
    selectedRole,
    selectedCaTemplate,
    selectedLanguage,
    isUpdateApprovalQueues,
    setSelectedLanguage,
    setActiveIndex,
    setSelectedCaTemplate,
    resetFilter
}: CreateTemplateApprovalQueuesePropTypes) => {

    const [createdSuccessTempdialogVisible, setCreatedSuccessTempdialogVisible] = useState<boolean>(false);
    const [approvalQueuesData, setApprovalQueuesData] = useState<any>([]);
    const [caApprovalOptions, setCaApprovalOptions] = useState<any>([]);
    const [loader, setLoader] = useState<boolean>(false);

    const { data: caLanguageData } = useGetCaLanguageQuery();
    const { data: caApprovalOptionsData } = useGetCaApprovalOptionsQuery();
    const { data: caApproverRolesData } = useGetCaApproverRolesQuery();
    const { data: caTemplateData } = useGetCaTemplateQuery({
        countryId: selectedCountry?.country_id,
        categoryId: selectedCategory?.ca_category_id,
        scorecardRoleId: selectedRole?.scorecard_role_id,
    },
        { skip: !selectedCountry?.country_id || !selectedCategory?.ca_category_id || !selectedRole?.scorecard_role_id }
    );
    const { data: caSeverityLevelData } = useGetCaSeverityLevelQuery({
        countryId: selectedCountry?.country_id,
        isHCUser: true,// Passing true to retrieve all severity levels without user-specific limitations
    });
    const { data: caApprovalQueuesByTemplateId } = useGetCaApprovalQueuesByTemplateIdQuery({
        templateId: selectedCaTemplate?.ca_template_id
    },
        { skip: !selectedCaTemplate?.ca_template_id }
    );
    const [insertCaApprovalQueues] = useInsertCaApprovalQueuesMutation();

    const createdSuccessTempDialogFuncMap = {
        createdSuccessTempDialogBox: setCreatedSuccessTempdialogVisible,
    };

    const onCreatedSuccessTempDialogBoxHide = () => {
        createdSuccessTempDialogFuncMap.createdSuccessTempDialogBox(false);
    };

    const handleClickReturn = () => {
        setActiveIndex(Tabindex.Search);
        onCreatedSuccessTempDialogBoxHide();
    };

    const handleClickConfigure = () => {
        setActiveIndex(Tabindex.Configuration);
        onCreatedSuccessTempDialogBoxHide();
    };
    useEffect(() => {
        const templateData = {
            "ca_template_id": caTemplateData?.data[0]?.ca_template_id,
            "ca_template_name": caTemplateData?.data[0]?.ca_template_name,
        }
        setSelectedCaTemplate(templateData);

    }, [caTemplateData])

    useEffect(() => {
        setLoader(true);
        const initialData: any = [];
        let initialOptionVal = caApprovalOptionsData?.data.filter((option: any) => option.ca_approval_queue_option_name.toLowerCase() === 'none')[0]?.ca_approval_queue_option_id;
        const noneValueSelection = initialOptionVal;
        const roles = [...caApproverRolesData?.data ?? []];
        const severityLevelData = [...caSeverityLevelData?.data ?? []];

        const header: any = {};
        header.roleName = "Role";
        header.roleId = 0;
        severityLevelData.forEach((level) => {
            header[level.severity_level_name] = level.severity_level_name;
        });

        initialData.push(header);

        roles.forEach((role) => {
            const obj: any = {};
            obj.roleName = role.ca_approver_role_name;
            obj.roleId = role.ca_approver_role_id;
            severityLevelData.forEach((level) => {
                if (isUpdateApprovalQueues && caApprovalQueuesByTemplateId?.data.length > 0) {
                    const optionVal: any = caApprovalQueuesByTemplateId?.data.filter(
                        (resp: any) =>
                            resp.ca_approver_role_id === role.ca_approver_role_id &&
                            resp.severity_level_id === level.severity_level_id
                    );
                    initialOptionVal = optionVal[0]?.ca_approval_queue_option_id ?? noneValueSelection;
                }
                obj[level.severity_level_name] = initialOptionVal;
            });
            initialData.push(obj);
        });
        setApprovalQueuesData(initialData);
        setLoader(false);
    }, [caSeverityLevelData, caApproverRolesData, caApprovalOptionsData, caApprovalQueuesByTemplateId]);

    useEffect(() => {
        if (caApprovalOptionsData?.data.length > 0) {
            setCaApprovalOptions(caApprovalOptionsData.data);
        }

    }, [caApprovalOptionsData])

    useEffect(() => {
        if (!selectedLanguage) {
            const defaultLan = caLanguageData?.data.filter(
                (lan: any) =>
                    lan.emp_language_name.toLowerCase() === 'english'
            )
            if (defaultLan !== undefined)
                setSelectedLanguage(defaultLan[0]?.emp_language_id);
        }

    }, [caLanguageData]);

    const CreatedSuccessfooterTemplate = (
        <div className='row'>
            <div className="col-md-6">
                <Button
                    className="btn-secondary"
                    onClick={handleClickReturn}
                    label={"Return to Search"}
                />
            </div>
            <div className="col-md-6">
                <Button
                    className="btn-primary w-100"
                    onClick={handleClickConfigure}
                    label={"Configure"}
                />
            </div>
        </div>
    );
    const selectedApprovalOptionTemplate = (option: any, props: any) => {
        if (option) {
            return (
                colorCodeOptions(option)
            );
        }
        return <span>{props.placeholder}</span>;
    }
    const colorCodeOptions = (option: any) => {
        let colorClass = 'noneColor';
        if (option.ca_approval_queue_option_name.toLowerCase() === "notify") {
            colorClass = 'notifyColor';
        }
        else if (option.ca_approval_queue_option_name.toLowerCase() === "approve") {
            colorClass = 'approverColor';
        }

        return <div className={`flex align-items-center ${colorClass}`}>
            <div>{option.ca_approval_queue_option_name}</div>
        </div>
    }
    const approvalOptionTemplate = (option: any) => {
        return (
            colorCodeOptions(option)
        );
    };

    const bodyTemplate = (rowData: any, columnName: string) => {
        if (!isNaN(rowData[columnName])) {
            return (
                <Dropdown
                    id='ca_approvalqueue_option'
                    placeholder="Select a Option"
                    className="custom-dropdown"
                    options={caApprovalOptions}
                    optionValue={'ca_approval_queue_option_id'}
                    optionLabel={'ca_approval_queue_option_name'}
                    value={rowData[columnName]}
                    itemTemplate={approvalOptionTemplate}
                    valueTemplate={selectedApprovalOptionTemplate}
                    onChange={(event: any) => handleOnChange(event, rowData, columnName)}
                />
            );
        };

        return (<span>{rowData[columnName]}</span>)

    };

    const handleOnChange = (event: any, rowData: any, columnName: string) => {
        const orignaleData = [...approvalQueuesData];
        orignaleData.forEach((data: any) => {
            if (data.roleName === rowData.roleName) {
                // eslint-disable-next-line no-param-reassign
                data[columnName] = event?.target?.value;
            }
        });
        setApprovalQueuesData(orignaleData);
    }
    const handleCreateClick = () => {
        const approvalQueues = approvalQueuesData?.slice(1, approvalQueuesData.length);
        const roles: any = [];
        approvalQueues.forEach((row: any) => {
            const levels: any = [];
            Object.entries(row).forEach(entry => {
                if (entry[0] !== "roleName" && entry[0] !== "roleId") {
                    const severid = caSeverityLevelData?.data.filter(
                        (lev: any) => lev.severity_level_name === entry[0])
                    [0]?.severity_level_id;
                    const severity = {
                        severityLevel: severid,
                        option: entry[1]
                    }
                    levels.push(severity);
                }
            });
            const role = {
                roleName: row.roleName,
                roleId: row.roleId,
                levels
            }
            roles.push(role);
        });
        const caApprovalQueuespayload = {
            templateId: caTemplateData?.data[0]?.ca_template_id,
            languageId: selectedLanguage,
            roles
        }
        InsertCaApprovalQueues(caApprovalQueuespayload);
    }
    const InsertCaApprovalQueues = (caApprovalQueuespayload: any) => {
        insertCaApprovalQueues(caApprovalQueuespayload)
            .unwrap()
            .then((data: any) => {
                if (data?.data) {
                    setCreatedSuccessTempdialogVisible(true);
                    return true;
                }
                return !isUpdateApprovalQueues ? toast.error('Create corrective action approval QUeues failed') : toast.error('Updating corrective action approval QUeues failed');;
            });
    }

    const renderDataTable = () => {
        const columnKeys = approvalQueuesData[0] && Object.keys(approvalQueuesData[0]);

        return (
            <DataTable
                value={approvalQueuesData}
                className="approver-queue-table"
            >
                {columnKeys && columnKeys.map((key: any, index: any) => (
                    (key !== "roleId" && <Column
                        key={index}
                        field={key}
                        body={(rowData, props) => bodyTemplate(rowData, props.field)}
                    />)
                ))}
            </DataTable>
        );
    }
    return (
        <div className="card border-0 p-3 ps-0">
            <div className="card-body p-0">
                <div className='row'>
                    <p><b>{`Creating Template: ${selectedCaTemplate?.ca_template_name ?? ''}`}</b></p>
                </div>
                <div className='row'>
                    <div className='col-md-9'>
                        <CaSearchFilter
                            selectedCategory={selectedCategory}
                            selectedCountry={selectedCountry}
                            selectedRole={selectedRole}
                            filterDisable
                        />
                    </div>
                    <div className='col-md-3 langugae-dropdown'>
                        <div className='content'>
                            <label htmlFor="countrydd">Default Language*</label>
                            <Dropdown
                                id='emp_language_id'
                                placeholder="Select a Language"
                                className="custom-dropdown"
                                options={caLanguageData?.data}
                                optionValue={'emp_language_id'}
                                optionLabel={'emp_language_name'}
                                value={selectedLanguage}
                                onChange={(e: any) => { setSelectedLanguage(e.value) }}
                            />
                        </div>
                    </div>
                </div>
                <p style={{ width: "12%", padding: "15px 0px", borderBottom: "4px #3299ff solid" }}><b>Approval Queues</b></p>
                <div className='row'>

                    {!loader ? renderDataTable() : <LoadingSpinner />}

                </div>
                <div className="d-flex justify-content-end gap-2 mt-3">
                    <Button
                        label="Cancel"
                        className="btn-secondary mb-2"
                        onClick={() => {
                            resetFilter();
                            onCreatedSuccessTempDialogBoxHide();
                            setActiveIndex(Tabindex.Search);
                        }}
                    />
                    <Button
                        type="button"
                        onClick={handleCreateClick}
                        label={!isUpdateApprovalQueues ? 'Create' : 'Update'}
                        className="btn-primary mb-2"
                    />
                </div>
            </div>

            <ControlDialogBox
                dialogVisibile={createdSuccessTempdialogVisible}
                footerTemplate={CreatedSuccessfooterTemplate}
                IconPath={CreatedTemplateIcon}
                subHeading={!isUpdateApprovalQueues ? "Template Created" : "Template Updated"}
                subHeadingColor={"#64D96E"}
                msgText={
                    !isUpdateApprovalQueues ?
                        `Creating ${selectedCaTemplate?.ca_template_name ?? ''} has been created.Please configure Severity Levels` :
                        `Updated ${selectedCaTemplate?.ca_template_name ?? ''} has been updated.Please configure Severity Levels`
                }
                onDialogBoxHide={onCreatedSuccessTempDialogBoxHide}
            />
        </div>
    )
}